import { useAuthorization } from '@/modules/auth/useAuthorization';

/**
 * The franchise-wide permissions that gate the Franchise admin area (ADR 0015). Holding any
 * one of these at franchise-wide scope reveals the "Franchise administration" entry in the
 * Venue workspace sidebar and lets a user past the `/admin` guard. It is the union of the
 * permissions that gate the individual admin pages — a user who can reach at least one admin
 * page belongs in the admin shell.
 *
 * UX only: the backend 403 stays authoritative on every admin page (ADR 0007).
 */
export const FRANCHISE_ADMIN_PERMISSIONS = [
  'iam.user.manage',
  'iam.role.manage',
  'audit.read',
  'franchise.brand.manage',
  'franchise.country.manage',
  'venue.view',
  'venue.manage',
  'venue.waiver_template.manage',
  'workforce.employee.view',
  'workforce.employee.manage',
];

/** Whether the current user may enter the Franchise admin area (any franchise-wide admin grant). */
export function useCanEnterAdmin(): boolean {
  const auth = useAuthorization();
  return auth.canAny(FRANCHISE_ADMIN_PERMISSIONS);
}
